import { Box, Modal } from '@mui/material';
import { Trobber } from 'helpers/Trobber';

import { modalRootSx, trobberContainerSx } from './styles';

interface TrobberProps {
  isOpen?: boolean;
}

// Модалка с троббером
export const ModalTrobber = ({ isOpen }: TrobberProps) => {
  const renderContent = () => (
    <Modal open={isOpen ?? false}>
      <Box sx={modalRootSx}>
        <Box sx={trobberContainerSx}>
          <Trobber />
        </Box>
      </Box>
    </Modal>
  );

  return renderContent();
};
